import { render, staticRenderFns } from "./TunnelMigration.vue?vue&type=template&id=f66f152e&scoped=true"
import script from "./TunnelMigration.vue?vue&type=script&lang=js"
export * from "./TunnelMigration.vue?vue&type=script&lang=js"
import style0 from "./TunnelMigration.vue?vue&type=style&index=0&id=f66f152e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f152e",
  null
  
)

export default component.exports